module.exports = __webpack_public_path__ + "img/gpp_bad.6a2a8a34.svg";